import React, { ReactElement, useEffect } from 'react';
import styled from 'styled-components';

import { Portal } from './portal';

const Modal = ({
  children,
  close,
  render,
  modalWidth,
  centerMode,
  closeBtnFlag = false,
  closeBtnCross = false,
}: {
  children?: ReactElement;
  close?: any;
  render: any;
  closeBtnFlag?: boolean;
  closeBtnCross?: boolean;
}) => {

  useEffect(() => {
    document.body.style.overflowY = "hidden";
    return () => {
      document.body.style.overflowY = "visible";
    }
  }, []);

  return (
    <Portal>
      <ModalContainer
        centerMode={centerMode}
      >
        <MainModal modalWidth={modalWidth}>
          { closeBtnCross && <div
            className="modalClose"
            onClick={() => close()}>
            X
          </div> }
          {render(children) || children}
          {closeBtnFlag && <button onClick={() => close()}>Close</button>}
        </MainModal>
        <ModalOverlay onClick={() => close()} />
      </ModalContainer>
    </Portal>
  );
};

export { Modal };

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  overflow: scroll;
  bottom: 0;
  right: 0;
  z-index: 13;
  ${p => p.centerMode && `
    display: flex;
    align-items: center;
  `}
`;

const MainModal = styled.div`
  width: ${p => p.modalWidth ? p.modalWidth : ''};
  border-radius: 1rem;
  position: relative;
  top: 20rem;
  margin: 0 auto;
  margin-bottom: 4rem;
  z-index: 14;
  display: flex;
  align-items: center;
  justify-content: center;
  .modalClose {
    position: absolute;
    right: 4rem;
    top: 3rem;
    cursor: pointer;
  }
`;

const ModalOverlay = styled.div`
  z-index: 11;
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
`;